import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { AppProvider } from "./Context/Context";
import { store } from "./store";
import App from "./App";
import "./index.css";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.handleRedirectPromise().then((response) => {
  if (response !== null && response.account) {
    msalInstance.setActiveAccount(response.account);
  } else {
    const allAccounts = msalInstance.getAllAccounts();
    if (allAccounts.length > 0) {
      msalInstance.setActiveAccount(allAccounts[0]);
    }
  }

  const root = createRoot(document.getElementById("root"));

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <ReduxProvider store={store}>
            <AppProvider>
              <App />
            </AppProvider>
          </ReduxProvider>
        </MsalProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
});
